<template>
  <div class="account-page">
    <!-- Main Wrapper -->
    <div class="main-wrapper">
      <div class="account-content">
        <!-- <router-link to="/job/job-list" class="btn btn-primary apply-btn"
          >Apply Job</router-link
        > -->
        <div class="container">
          <!-- Account Logo -->
          <div class="account-logo">
            <img src="@/assets/img/swype.png" alt="swype"
            />
          </div>
          <!-- /Account Logo -->

          <div class="account-box">
            <div class="account-wrapper">
              <h3 class="account-title">Login</h3>
              <p class="account-subtitle">Access to our dashboard</p>

              <!-- Account Form -->
              <Form @submit="onSubmit" :validation-schema="schema" v-slot="{ errors }">
                <div class="input-block mb-4">
                  <label class="col-form-label">Email</label>
                  <Field
                    name="employeeEmail"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.employeeEmail }"
                  />
                  <div class="invalid-feedback">{{ errors.employeeEmail }}</div>
                  <div class="emailshow text-danger" id="employeeEmail"></div>
                </div>
                <div class="input-block mb-4">
                  <div class="row align-items-center">
                    <div class="col">
                      <label class="col-form-label">Password</label>
                    </div>
                    <!-- <div class="col-auto">
                      <router-link class="text-muted" to="forgot-password">
                        Forgot password?
                      </router-link>
                    </div> -->
                  </div>
                  <div class="position-relative pass-group">
                    <Field
                      name="password"
                      :type="showPassword ? 'text' : 'password'"
                      class="form-control pass-input mt-2"
                      :class="{ 'is-invalid': errors.password }"
                    />
                    <span @click="toggleShow" class="toggle-password">
                      <i
                        :class="{
                          'fas fa-eye': showPassword,
                          'fas fa-eye-slash': !showPassword,
                        }"
                      ></i>
                    </span>
                    <div class="invalid-feedback">{{ errors.password }}</div>
                    <div class="emailshow text-danger" id="password"></div>
                  </div>
                </div>

                <div class="input-block mb-4 text-center">
                  <button class="btn btn-primary account-btn" type="submit" :disabled="loading">
                    <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    {{ loading ? 'Logging in...' : 'Login' }}
                  </button>
                </div>
                <!-- <div class="account-footer">
                  <p>
                    Don't have an account yet?
                    <router-link to="register">Register</router-link>
                  </p>
                </div> -->
              </Form>
              <!-- /Account Form -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Main Wrapper -->
  </div>
</template>
<script>
import { Form, Field } from "vee-validate";
import axios from "axios";
import {VUE_APP_API_BASE_URL} from "../../../../config";
import * as Yup from "yup";
export default {
  components: {
    Form,
    Field,
  },
  data() {
    return {
      showPassword: false,
      employeeCode: null,
      password: null,
      employeeCodeError: "",
      passwordError: "",
      loading: false,
    };
  },
  computed: {
    buttonLabel() {
      return this.showPassword ? "Hide" : "Show";
    },
  },
  mounted() {
  
    
  },
  methods: {
    toggleShow() {
      this.showPassword = !this.showPassword;
    },
    onSubmit(values) {
      this.loading = true;
      this.emailError = "";
      this.passwordError = "";
      let headers = {
         "Access-Control-Allow-Headers":"*",
        "content-type":"application/json",
        "Accept":"*/*"
        };
      axios.post(VUE_APP_API_BASE_URL+'/login', {
      // axios.post(`${process.env.VUE_APP_API_BASE_URL}/login`, {
                    email: values.employeeEmail,
                    password: values.password,
                }, headers)
                .then((response) => {
                    if (response.data.status) {
                        // this.$store?.dispatch("auth/storeToken", response.data.data.token);
                        this.$store?.dispatch("auth/storeToken", response.data.data);
                        // this.$store?.dispatch("storeToken");
                        if(response.data.data.token){
                          axios.defaults.headers.common["Authorization"] = "Bearer " + response.data.data.token;
                              }   
                         if(response.data.data.account_type === "MEMBER"){
                            this.$router.push("/employee/holidays");
                         }else{
                          this.$router.push("/employee/employee-list");
                         }
                          

                    } else {
                        this.$toast.error(response.data.message || response.data.errors);
                        this.errorMessage = response.data.message ?? "";
                    }
                })
                .finally(() => {
                    this.loading = false;
                });

      // let data = localStorage.getItem("storedData");
      // var Pdata = JSON.parse(data);
      // const Eresult = Pdata.find(({ email }) => email === values.email);
      // if (Eresult) {
      //   if (Eresult.password === values.password) {
      //     this.$router.push("/dashboard/"); // Use this.$router instead of router
      //   } else {
      //     this.passwordError = "Incorrect password";
      //   }
      // } else {
      //   this.employeeCodeError = "Email is not valid";
      // }
      // let data = localStorage.getItem("storedData");
      // // this.$store?.dispatch("auth/storeToken", 1);
      // // store.dispatch("auth/login", data);
      // var Pdata = JSON.parse(data);
      // console.log(data);
      // const Eresult = Pdata.find(({ employeeId }) => employeeId === values.employeeId);
      // if (Eresult) {
      //   if (Eresult.password === values.password) {
      //     this.$router.push("/dashboard"); // Use this.$router instead of router
      //   } else {
      //     this.passwordError = "Incorrect password";
      //   }
      // } else {
      //   this.emailError = "Email is not valid";
      // }
    },
  },
  setup() {
    // let users = localStorage.getItem("storedData");
    // if (users === null) {
    //   let password = [
    //     {
    //       employeeId: "example@dreamstechnologies.com",
    //       password: "123456",
    //     },
    //   ];
    //   const jsonData = JSON.stringify(password);
    //   localStorage.setItem("storedData", jsonData);
    // }
    const schema = Yup.object().shape({
      employeeEmail: Yup.string().required("Email is required").email(),
      password: Yup.string()
        .min(8, "Password must be at least 8 characters")
        .required("Password is required"),
    });
    return {
      schema,
    };
  },
};
</script>

<style scoped>
.pass-input.is-invalid + .toggle-password {
  bottom: 0;
}
 .toggle-password {
    top: 25px !important;
    right: 28px;
    position: absolute;
}
</style>